/** Показывается, когда карты нет: нет данных или библиотека ещё грузится. */
export function MapPlaceholder({ text }: { text: string }) {
  return <div className="map map-empty">{text}</div>;
}
